module.exports = __webpack_public_path__ + "img/ng.ffd18fe3.svg";